<template>
  <div>
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '用户',
          url: '/member/list',
        },
        {
          title: '用户列表',
          active: true,
        },
      ]"
    ></vs-breadcrumb>

    <div class="mb-3 mt-4 float-right">
      <vs-input class="inline-block" v-model="keywords" placeholder="用户名" />
      <vs-button @click="reserviseParam" class="inline-block">搜索</vs-button>
    </div>

    <div>
      <vs-table
        ref="table"
        :notSpacer="false"
        :stripe="true"
        :max-items="itemsPerPage"
        :data="list"
        :noDataText="noDataText"
      >
        <template slot="thead" class="v_member_list_h">
          <vs-th width="1%">#</vs-th>
          <vs-th width="4%">用户信息</vs-th>
          <vs-th width="1%" style="white-space: nowrap">姓名</vs-th>
          <vs-th width="1%" style="white-space: nowrap">身份证号</vs-th>
          <vs-th width="1%">注册时间</vs-th>
          <vs-th width="1%">更新时间</vs-th>
          <vs-th>收货地址</vs-th>
          <vs-th width="1%">状态</vs-th>
          <vs-th width="1%">订单详情</vs-th>
          <vs-th width="1%">操作</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td>
                <p>{{ tr.id }}</p>
              </vs-td>
              <vs-td class="user_av_td" v-if="tr.avatarurl">
                <a class="w-16 h-16 flex items-center justify-center">
                  <img
                    :src="tr.avatarurl"
                    class="w-full h-full block"
                    style="border-radius: 50%"
                  />
                </a>
                <div class="pl-2 flex flex-col justify-center items-center">
                  <p class="block" style="white-space: nowrap">
                    {{ tr.nickname || '--' }}
                  </p>
                  <p class="block">{{ tr.phone || '--' }}</p>
                </div>
              </vs-td>
              <vs-td v-else>--</vs-td>
              <vs-td style="white-space: nowrap">
                <p>{{ tr.realname || '--' }}</p>
              </vs-td>
              <vs-td>
                <p>
                  {{ tr.idcard || '--' }}
                </p>
              </vs-td>
              <vs-td>
                <p style="white-space: nowrap">
                  {{ tr.created_at || '--' }}
                </p>
              </vs-td>
              <vs-td>
                <p style="white-space: nowrap">
                  {{ tr.updated_at || '--' }}
                </p>
              </vs-td>
              <vs-td>
                <div
                  v-for="item in tr.address"
                  :key="item.id"
                  @click="showEditModal_Add(item.id, tr.id)"
                  style="white-space: nowrap; cursor: pointer"
                >
                  {{ `${item.name}` }}&nbsp;{{
                    `${item.province}${item.city}${item.district}${item.address}`
                  }}
                </div>
              </vs-td>
              <vs-td>
                <vs-switch v-model="tr.status" @input="switchStatus(tr)" />
              </vs-td>
              <vs-td>
                <div
                  @click="gotoOrderList(tr.id)"
                  style="white-space: nowrap; cursor: pointer"
                >
                  查看订单
                </div>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div>
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current a-hover"
                    class="ml-2"
                    @click.stop="deleteData(tr.id, tr.realname)"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <vs-pagination
        class="mt-6"
        :total="totalPage"
        v-model="currentx"
        @input="gotoCurrentPage"
      ></vs-pagination>
    </div>

    <!-- <vs-popup
      class="holamundo"
      title="收货地址"
      :active.sync="popupAddress"
    >
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">收件人</label>
            <vs-input
              class="w-full"
              v-model="name"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">电话</label>
            <vs-input
              class="w-full"
              v-model="phone"
            />
          </div>
        </div>
        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <label class="mb-5">收货地址</label><br>
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="region"
                  @change="addressChange"
                >
                </el-cascader>
          </div>
        </div>
        <div class="vx-row justify-end">
          <div class="vx-col">
            <vs-button
              class="mr-3"
              @click="editConfirm"
              :disabled="btnDisabled"
            >确认修改</vs-button>
            <vs-button
              type="border"
              @click="popupAddress=false;
              name = '';
              phone = '';
              addressPosition = '';"
              :disabled="btnDisabled"
            >关闭</vs-button>
          </div>
        </div>
      </div>
    </vs-popup> -->

    <el-dialog :visible.sync="popupAddress">
      <span
        slot="title"
        class="dialog-header el_add_hea"
        style="
          width: 112px;
          height: 40px;
          font-weight: 500;
          font-size: 28px;
          color: #5e5873;
        "
      >
        收货地址
      </span>
      <div class>
        <div class="vx-row mb-4 justify-center">
          <div class="vx-col w-full">
            <label class="mb-5">收件人</label>
            <vs-input v-model="personAdmin.name" />
          </div>
        </div>
        <div class="vx-row mb-4 justify-center">
          <div class="vx-col w-full">
            <label class="mb-5">电话</label>
            <vs-input v-model="personAdmin.phone" />
          </div>
        </div>
        <div class="vx-row mb-4 justify-center">
          <div class="vx-col w-full">
            <label class="mb-5">收货地址</label><br />
            <el-cascader
              size="medium"
              :options="options"
              v-model="region"
              @change="addressChange"
            >
            </el-cascader>

            <vs-input
              style="display: inline-block; margin-left: 1rem"
              placeholder="请输入详细地址"
              v-model="personAdmin.address"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            popupAddress = false
            personAdmin.address = ''
            personAdmin.phone = ''
            region = []
          "
          >取消</el-button
        >
        <el-button type="primary" @click="editConfirm">确认</el-button>
      </span>
    </el-dialog>

    <vs-popup title="删除用户" :active.sync="delPopUpActive">
      <div class>
        <div class="mb-4">是否确认删除用户: {{ curName }}?</div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="delConfirm" :disabled="btnDisabled"
              >确认删除</vs-button
            >
            <vs-button
              type="border"
              @click="
                delPopUpActive = false
                btnDisabled = false
                curName = ''
              "
              :disabled="btnDisabled"
              >关闭</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import memberRepo from '@/repo/member'
export default {
  name: 'memberList',

  data: () => ({
    region: [],
    options: [],
    // phone: '',
    personAdmin: {
      address: '',
      phone: '',
      name: '',
    },
    personAdmin_P: {},
    // name: '',
    btnDisabled: false,
    popupAddress: false,
    searchParams: {},
    list: [],
    page: 1,
    itemsPerPage: 20,
    totalPage: 0,
    noDataText: '',
    keywords: null,
    currentx: 1,
    headsContent_T: [
      '#',
      '用户信息',
      '姓名',
      '身份证号',
      '注册时间',
      '更新时间',
      '收货地址',
      '状态',
      '订单详情',
      '操作',
    ],
    postId: '',
    curName: '',
    curId: '',
    delPopUpActive: false,
  }),
  mounted() {
    this.getListData()
  },
  created() {
    this.options = this.area.getRegions()
  },
  computed: {},

  watch: {
    popupAddress: {
      handler(newV, oldV) {
        if (newV == false && oldV) {
          this.postId = ''
        }
      },
    },
  },
  methods: {
    addressChange(bindValue) {
      if (bindValue) {
        let area = this.area.CodeToText()
        this.personAdmin_P.province = area[bindValue[0]]
        this.personAdmin_P.city = area[bindValue[1]]
        this.personAdmin_P.district = area[bindValue[2]]
      }
    },
    deleteData(id, name) {
      this.curName = name
      this.delPopUpActive = true
      this.curId = id
    },

    delConfirm() {
      this.btnDisabled = true
      let idP
      idP = this.curId
      let that = this
      memberRepo.deleteData(idP, (error, resp) => {
        if (resp.code == 0) {
          that.delPopUpActive = false
          that.getListData()
        } else {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
      setTimeout(() => {
        that.btnDisabled = false
      }, 1000)
    },

    gotoOrderList(id) {
      let pushList = this.$router.resolve({
        name: 'order',
        query: {
          u_id: id,
        },
      })

      window.open(pushList.href, '_blank')
    },

    reserviseParam() {
      this.page = 1
      this.getListData()
    },

    gotoCurrentPage() {
      this.page = this.currentx
      this.getListData()
    },

    showEditModal_Add(id, tr_id) {
      if (id) {
        this.postId = id
        this.popupAddress = true
        let that = this
        memberRepo.getAddDetail(id, (error, resp) => {
          if (
            resp.code == 0 &&
            Object.keys(resp.data).length &&
            resp.data.address
          ) {
            that.personAdmin.name = resp.data.name
            that.personAdmin.phone = resp.data.phone
            that.personAdmin.address = resp.data.address

            if (resp.data.province) {
              let areasItems = that.area.TextToCode()
              let consignee = []
              if (resp.data.province) {
                let provinceItems = that.area.provinceTextToCode()
                consignee.push(provinceItems[resp.data.province])
              }
              if (resp.data.city) {
                let cityItems = that.area.cityTextToCode()
                consignee.push(cityItems[resp.data.city])
              }
              if (resp.data.district) {
                consignee.push(areasItems[resp.data.district])
              }
              that.region = consignee
            }
          } else {
            that.personAdmin.name = ''
            that.personAdmin.phone = ''
            that.$vs.notify({
              position: 'bottom-center',
              color: 'danger',
              title: '错误提示',
              text: resp.msg,
            })
          }
        })
      }
    },

    /**
     * @description fetch list
     */
    getListData() {
      this.$vs.loading()
      const page = this.page
      const per_page = this.itemsPerPage
      const keywords = this.keywords
      let that = this
      memberRepo.list(page, per_page, keywords, (error, resp) => {
        that.$vs.loading.close()
        if (resp.code == 0) {
          that.list = JSON.parse(JSON.stringify(resp.data.data))
          const total = parseInt(resp.data.total)
          const perCount = parseInt(resp.data.per_page)
          that.totalPage = Math.ceil(total / perCount)
          if (that.totalPage === 0) {
            that.noDataText = '数据为空'
          } else {
            that.noDataText = ''
          }
        }
      })
    },

    editConfirm() {
      let params = this.personAdmin

      if (!String(this.personAdmin.phone).trim()) {
        this.$vs.notify({
          position: 'bottom-center',
          color: 'danger',
          title: '错误提示',
          text: '没有电话',
        })
        return
      }

      if (!String(this.personAdmin.name).trim()) {
        this.$vs.notify({
          position: 'bottom-center',
          color: 'danger',
          title: '错误提示',
          text: '没有收件人',
        })
        return
      }

      if (!this.region.length) {
        this.$message.warning('请选择收货地址')
        return
      }

      //省市区
      if (this.personAdmin_P) {
        let get_item = JSON.parse(JSON.stringify(this.personAdmin_P))
        params.province = get_item.province
        params.city = get_item.city
        params.district = get_item.district
      }
      //----

      let that = this
      memberRepo.editAddress(params, this.postId, (error, resp) => {
        if (resp.code == 0) {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'success',
            title: '操作提示',
            text: resp.msg,
          })
          that.popupAddress = false
          that.getListData()
        } else {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
    },

    switchStatus(e) {
      let { id, status } = e
      status = status ? 1 : 0
      if (id) {
        let params = { status: status }
        // if (tr.status) ?
        let that = this
        memberRepo.updateMemberAble(params, id, (error, resp) => {
          if (resp.code == 0) {
            that.$vs.notify({
              position: 'bottom-center',
              color: 'success',
              title: '操作提示',
              text: resp.msg,
            })
          } else {
            that.$vs.notify({
              position: 'bottom-center',
              color: 'danger',
              title: '错误提示',
              text: resp.msg,
            })
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
.user_av_td > span:first-child {
  display: flex;
}
.v_member_list_h th {
  white-space: nowrap;
}
</style>
